module.exports = __webpack_public_path__ + "img/ic_benifit_member.264f5a0f.png";